import React, { useEffect, useState, memo } from 'react';
import { TbBulb } from 'react-icons/tb';
import { Capitalize, optionsCreator } from './../../functions/commonFunctions';
import {
  getNarrativeFilters,
  getNarrativeforQuarter
} from '../../services/summaryService';
import ModalBox from '../../components/modal';
import parse from 'html-react-parser';
import { BsChatSquareDots } from 'react-icons/bs';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { Triangle } from 'react-loader-spinner';
import Select from '../../components/customSelect';

const BusinessNarratives = (props) => {
  const [dimsummary, setDimensionSummary] = useState([]);
  const [loader, setLoader] = useState(true);
  const [loadermessage, setLoaderMessage] = useState('');

  const [quarter, setQuarter] = useState('');
  const [quarterlist, setQuarterList] = useState([]);
  const [selectloader, setSelectLoader] = useState(true);

  useEffect(() => {
    async function getData() {
      try {
        setLoader(true);
        // enable loader messages
        const messages = [
          'Fetching Persona details',
          'Identifying preferred metrics',
          'Sending preference to Gen AI',
          'Fetching key insights',
          'Summarizing insights',
          'Finalising results',
          'Please wait few more seconds'
        ];
        let count = 0;
        setLoaderMessage(messages[count]);
        const interval = setInterval(function message() {
          count += 1;
          setLoaderMessage(messages[count]);
          if (count === messages.length - 1) clearInterval(interval);
        }, 3000);
        // check for data in local storage
        if (!sessionStorage.getItem('x_exec_summary')) {
          const { data: descriptive_summary } = await getNarrativeforQuarter({
            latest: true,
            quarter_year: ''
          });
          sessionStorage.setItem(
            'x_exec_summary',
            JSON.stringify(descriptive_summary)
          );
          setQuarter(descriptive_summary[0].quarter_year);
          props.updateDate(descriptive_summary[0].date);
          setDimensionSummary(descriptive_summary);
        }
        // use local storage data
        else {
          const descriptive_summary = JSON.parse(
            sessionStorage.getItem('x_exec_summary')
          );
          setQuarter(descriptive_summary[0].quarter_year);
          props.updateDate(descriptive_summary[0].date);
          setDimensionSummary(descriptive_summary);
        }
        setLoader(false);
      } catch (err) {
        setLoader(false);
        console.log(err);
      }
    }
    getData();
  }, [props.user.user_uuid, props]);

  const SeeMore = (
    <span className='ms-2'>
      See more <HiOutlineArrowNarrowRight />
    </span>
  );

  const fetchOptions = async (column) => {
    setSelectLoader(true);
    try {
      const { data: column_value } = await getNarrativeFilters(column);
      setQuarterList(column_value);
      setSelectLoader(false);
    } catch (err) {
      console.log(err);
      setSelectLoader(false);
    }
  };

  const updateSelection = async (option) => {
    setLoader(true);
    setQuarter(option[0].value);
    const { data: descriptive_summary } = await getNarrativeforQuarter({
      latest: false,
      quarter_year: option[0].value
    });
    sessionStorage.setItem(
      'x_exec_summary',
      JSON.stringify(descriptive_summary)
    );
    setDimensionSummary(descriptive_summary);
    props.updateDate(descriptive_summary[0].date);
    setLoader(false);
  };

  return (
    <div className='narratives mt-4 place-container'>
      <h5 className='mb-4 title'>
        <BsChatSquareDots />
        <span>Business Narrative</span>
        <Select
          options={optionsCreator(quarterlist) || []}
          defaultselection={optionsCreator([quarter]) || []}
          name={'quarter'}
          placeholder={'Select one quarter'}
          customclass='quarter-filter'
          onChange={(s) => updateSelection(s)}
          loader={selectloader}
          loadoptionseverytime={true}
          loadoptionfunc={() => fetchOptions('quarter_year')}
        />
      </h5>
      {/* KEY METRICS PERFORMAMCE */}
      {/* <div className='row m-0'>
        <div className='col-xs-12 col-md-12 col-lg-12'>
          {!loader &&
            kpisummary.length > 0 &&
            kpisummary.map((x, i) => {
              const text_length = 300;
              const text = x.summary.length > text_length ? true : false;
              return (
                <div className='x-card-kpi' key={i}>
                  <div className='narrative-heading'>
                    <TbBulb /> Key Metrics Performance
                  </div>
                  <div>
                    {text ? x.summary.substring(0, text_length - 1) : x.summary}
                    <span className='see-more'>{text ? SeeMore : ''}</span>
                  </div>
                </div>
              );
            })}
          {loader && <div className='loader mb-3'>{PlaceHolder()}</div>}
        </div>
      </div> */}
      {/* LEVEL PERFORMAMCE */}
      <div className='row m-0'>
        {!loader &&
          dimsummary.length > 0 &&
          dimsummary.map((x) => {
            const cardlength = Math.max(4, Math.floor(12 / dimsummary.length));
            const text_length = cardlength === 12 ? 800 : 380;
            const text = x.narrative.length > text_length ? true : false;
            const title = Capitalize(x.metric) + ' Performance';
            const content = text
              ? x.narrative.substring(0, text_length - 1)
              : x.narrative;
            const index = x.date + x.metric.replace(' | ', '');
            return (
              <div
                className={`col-xs-12 col-md-${cardlength} col-lg-${cardlength} mb-3`}
                key={index}
              >
                <div className='x-card'>
                  <div className='narrative-heading'>
                    <TbBulb />{' '}
                    <span className='flex-fill'>
                      {Capitalize(title.replaceAll('_', ' '))}
                    </span>
                  </div>
                  <div className='summary-content'>
                    {content}
                    <span
                      className='see-more'
                      data-bs-toggle='modal'
                      data-bs-target={'#see-more' + index}
                    >
                      {text ? SeeMore : ''}
                    </span>
                  </div>
                  <ModalBox
                    id={'see-more' + index}
                    icon={<TbBulb />}
                    header={title}
                    content={
                      <div className='d-flex popup'>
                        <div>{parse(x.narrative.replace(/\n/g, '<br/>'))}</div>
                      </div>
                    }
                  />
                </div>
              </div>
            );
          })}
        {loader && (
          <div className='loader'>
            <Triangle
              height='80'
              width='80'
              ariaLabel='triangle-loading'
              wrapperStyle={{}}
              wrapperClassName=''
              visible={true}
            />
            <span>{loadermessage}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(BusinessNarratives);
